<template lang="pug">
  layout(content-style="grey-lighter")

    template(v-slot:toolbar)
      b-navbar
        template(v-slot:start)
          .navbar-item(v-if="totalQuestions")
            b-taglist(attached)
              b-tag.is-dark Вопрос
              b-tag.is-cyan {{questionNumber}} из {{totalQuestions}}
          .navbar-item(v-if="countdown>0")
            b-taglist(attached)
              b-tag.is-dark Оставшееся время
              b-tag.is-warning {{testingTime}}

          //- {{testingTime}} | {{countdown}}
    template(v-slot:content)
      section.section.container
        b-message(v-if="complete" type='is-success' has-icon)
          .button.is-primary.is-pulled-right(@click="reset") Вернуться к списку тестов
          div Тестирование завершено
        template(v-else)
          .content
            div(v-if="currentQuestion")
              h2 {{ currentQuestion.title }}

              p(v-if="currentQuestion.description") {{ currentQuestion.description }}

              .box(v-if="currentQuestion.hasChoice() && currentQuestion.answers")
                b-field(v-for="answer in currentQuestion.answers.items" :key="answer.id")
                  b-checkbox(v-if="currentQuestion.multiple" v-model="answersValues" :native-value="answer.id")
                    answer(:value="answer")
                  b-radio(v-else v-model="answersValue" :native-value="answer.id")
                    answer(:value="answer")

              .box(v-if="currentQuestion.free_answer || ['input', 'arbitrary'].includes(currentQuestion.type)")
                b-field(label="Ваш ответ")
                  b-input(v-model="answerInput" :type="currentQuestion.type === 'input' ? 'text' : 'textarea'")
              br
              span.button.is-large.is-cyan(@click="ask" :disabled="!canSendAnswer") Ответить

            template(v-else-if="tests.items.length")
              //- h1.header.has-text-light Доступные тесты
              .columns.is-multiline
                .column.is-6(v-if="tests" v-for="test in tests.items")
                  test-card(:test="test")
                //- .column.is-6(v-if="tests" v-for="test in tests.items")
                  test-card(:test="test")
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api';
import Test from '@/models/Test';
import TestQuestion from '@/models/TestQuestion';

export default {
  name: 'view-site-tests',

  data: () => ({
    test: new Test(),
    tests: Test.collection(),
    currentQuestion: null,
    answersValue: null,
    answersValues: [],
    answerInput: '',
    complete: false,
    questionNumber: 0,
    totalQuestions: 0,
  }),

  computed: {
    ...mapGetters({
      countdown: 'getTestCountdown',
      testingTime: 'getTestingTime',
      testSession: 'getTestSession',
    }),

    testId() {
      return this.testSession ? this.testSession.test_id : 0;
    },
    canSendAnswer() {
      return this.answersValue || this.answersValues.length || this.answerInput;
    },
  },

  watch: {
    testId(testId) {
      this.loadTest(testId);
    },
  },

  methods: {
    reset() {
      this.complete = false;
      this.currentQuestion = null;
    },

    resertAnswer() {
      this.answersValue = null;
      this.answersValues = [];
      this.answerInput = '';
    },

    async loadNextQuestion() {
      this.resertAnswer();

      const response = await api.for(`test-sessions/${this.testSession.id}/next-question`).fetch();
      let meta = response.meta;

      if (meta) {
        this.questionNumber = meta.question_number;
        this.totalQuestions = meta.total_questions;
      }

      this.currentQuestion = new TestQuestion(response.data);
    },

    async finishTest() {
      this.testSession.complete = 1;
      this.$store.commit('stopCountdown');
      this.complete = true;

      this.questionNumber = 0;
      this.totalQuestions = 0;

      this.resertAnswer();
    },

    async loadTest(testId) {
      await this.test.$find(testId);

      await this.loadNextQuestion();
    },

    async ask() {
      if (!this.canSendAnswer) {
        return;
      }

      const answerData = this.currentQuestion.hasChoice()
        ? {
            answers: this.currentQuestion.multiple ? this.answersValues : [this.answersValue],
            input: this.answerInput,
          }
        : { input: this.answerInput };
      const response = await api
        .for(`test-sessions/${this.testSession.id}/answer`)
        .create(answerData);

      if (response.data.complete) {
        this.finishTest();
      } else {
        this.loadNextQuestion();
      }
    },
  },

  created() {
    if (this.testId) {
      this.loadTest(this.testId);
    }

    this.tests.$fetch({
      filter: { active: 1 },
      include: 'userSessions',
    });
  },
};
</script>
